import { ReactElement } from 'react';
import { Layout } from 'components/layouts/Layout';
import { AppProvider } from 'store/AppContext';
import { AppRoutes } from './routes/AppRoutes';

const App = (): ReactElement => {
  return (
    <AppProvider>
      <Layout>
        <AppRoutes />
      </Layout>
    </AppProvider>
  );
};

export default App;
